import { cn } from "@/lib/utils"

import logoUrl from "@/assets/hu-logo-small.svg"

export function HuLogoSmall({ className }: { className?: string }) {
  return (
    <span
      aria-hidden
      className={cn("inline-block size-7 shrink-0 bg-current", className)}
      style={{
        mask: `url("${logoUrl}") center / contain no-repeat`,
        WebkitMask: `url("${logoUrl}") center / contain no-repeat`,
      }}
    />
  )
}
